//React
import React from "react"
import { useNavigate } from "react-router-dom"
//Icons
import { faCalendar, faHouse, faUser } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"

//k = key
export default function BuildingItem({ building }) {
  const navigate = useNavigate()
  return (
    <div
      key={building.id}
      className="hoverMe innerCon p-2 d-flex flex-md-column align-items-center justify-content-between"
      onClick={() => navigate(`/community_assets/view_asset/${building.id}`)}
    >
      <div className="mb-md-2"></div>
      <div className="d-flex flex-column justify-content-center align-items-center mb-md-2">
        <h5 className="d-flex">{building.assetName}</h5>
        <div className="d-flex">{building.assetType}</div>
        <div className="d-flex">{building.district}</div>
        <div className="d-flex">{building.parish}</div>
      </div>

      <div>
        <button className="btn btn-primary">View</button>
      </div>
    </div>
  )
}
